export type DeploymentEnvironment = 'development' | 'qa' | 'staging' | 'production';

const supportedEnvironments: DeploymentEnvironment[] = [
	'development',
	'qa',
	'staging',
	'production',
];

export const resolveDeploymentEnvironment = (
	nodeEnvironment: string | undefined,
	requestedEnvironment: string | undefined,
): DeploymentEnvironment => {
	if (nodeEnvironment === 'test') {
		return 'development';
	}

	const normalizedRequestedEnvironment = String(requestedEnvironment || '')
		.trim()
		.toLowerCase();

	if (normalizedRequestedEnvironment) {
		if (!supportedEnvironments.includes(normalizedRequestedEnvironment as DeploymentEnvironment)) {
			throw new Error(
				`Unsupported frontend deployment environment: ${normalizedRequestedEnvironment}`,
			);
		}

		return normalizedRequestedEnvironment as DeploymentEnvironment;
	}

	if (nodeEnvironment === 'production') {
		return 'production';
	}

	return 'development';
};

const environmentByHostname: { [hostname: string]: DeploymentEnvironment } = {
	'app.staging.scrubplan.com': 'staging',
	'app.scrubplan.com': 'production',
};

export const assertDeploymentHostMatchesEnvironment = (
	deploymentEnvironment: DeploymentEnvironment,
	hostname: string,
): void => {
	const expectedEnvironment = environmentByHostname[String(hostname || '').trim().toLowerCase()];

	if (expectedEnvironment && expectedEnvironment !== deploymentEnvironment) {
		throw new Error(
			`Refusing to start ${deploymentEnvironment} frontend on ${hostname}; expected ${expectedEnvironment}`,
		);
	}
};
